var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultSocialIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_479_1355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1352 12.015C5.5652 11.9625 5.0027 11.7 4.5677 11.2425C3.5777 10.2 3.5777 8.49002 4.5677 7.44752L6.2102 5.72252C6.44213 5.47569 6.72216 5.27898 7.03302 5.14451C7.34389 5.01005 7.679 4.94067 8.0177 4.94067C8.35639 4.94067 8.69151 5.01005 9.00237 5.14451C9.31323 5.27898 9.59326 5.47569 9.8252 5.72252C10.8152 6.76502 10.8152 8.47502 9.8252 9.51752L9.0077 10.38",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8651 5.98499C12.4351 6.03749 12.9976 6.29999 13.4326 6.75749C14.4226 7.79999 14.4226 9.50999 13.4326 10.5525L11.7901 12.2775C11.5582 12.5243 11.2782 12.721 10.9673 12.8555C10.6564 12.99 10.3213 13.0593 9.98262 13.0593C9.64392 13.0593 9.30881 12.99 8.99794 12.8555C8.68708 12.721 8.40705 12.5243 8.17512 12.2775C7.18512 11.235 7.18512 9.52499 8.17512 8.48249L8.99262 7.61999",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 17.5H6.3C4.09931 17.5 2.68891 17.0568 1.81605 16.1839C0.943199 15.3111 0.5 13.9007 0.5 11.7V6.3C0.5 4.09931 0.943199 2.68891 1.81605 1.81605C2.68891 0.943199 4.09931 0.5 6.3 0.5H11.7C13.9007 0.5 15.3111 0.943199 16.1839 1.81605C17.0568 2.68891 17.5 4.09931 17.5 6.3V11.7C17.5 13.9007 17.0568 15.3111 16.1839 16.1839C15.3111 17.0568 13.9007 17.5 11.7 17.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_479_1355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSocialIcon);
export default __webpack_public_path__ + "static/media/default-social-icon.276a16469e3625cccc13b3896b8ddc4a.svg";
export { ForwardRef as ReactComponent };